import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "admin-topbar" }
const _hoisted_2 = { class: "admin-topbar-actions" }
const _hoisted_3 = { class: "admin-layout" }
const _hoisted_4 = { class: "admin-sidebar" }
const _hoisted_5 = { class: "admin-sidebar-nav" }
const _hoisted_6 = { class: "admin-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "admin-topbar-brand" }, [
        _createElementVNode("i", { class: "ti ti-device-tv" }),
        _createTextVNode(" goplayTv Admin ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: "/",
          target: "_blank",
          class: "admin-topbar-link"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "ti ti-world" }, null, -1),
            _createTextVNode(" View Site ")
          ])),
          _: 1
        }),
        _createElementVNode("button", {
          class: "admin-topbar-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "ti ti-logout" }, null, -1),
          _createTextVNode(" Logout ")
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("aside", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "admin-sidebar-brand" }, [
          _createElementVNode("i", {
            class: "ti ti-device-tv",
            style: {"color":"#c90e0e","font-size":"1.3rem"}
          }),
          _createElementVNode("span", null, "Admin Panel")
        ], -1)),
        _createElementVNode("nav", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
            return (_openBlock(), _createBlock(_component_RouterLink, {
              key: item.label,
              to: item.to,
              class: _normalizeClass(["admin-nav-item", { active: _ctx.isActive(item) }]),
              "active-class": "",
              "exact-active-class": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "admin-nav-item admin-nav-logout mt-auto",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "ti ti-logout" }, null, -1),
          _createElementVNode("span", null, "Logout", -1)
        ]))
      ]),
      _createElementVNode("main", _hoisted_6, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ], 64))
}